import { useEffect, useState } from 'react';
import { Modal, RenderInBody } from 'bv-components';
import { t } from 'bv-i18n';

const OfflineBubble = () => {
  const [online, isOnline] = useState(navigator.onLine);

  const setOnline = () => {
    isOnline(true);
  };
  const setOffline = () => {
    isOnline(false);
  };

  // Register the event listeners
  useEffect(() => {
    window.addEventListener('offline', setOffline);
    window.addEventListener('online', setOnline);

    // cleanup if we unmount
    return () => {
      window.removeEventListener('offline', setOffline);
      window.removeEventListener('online', setOnline);
    };
  }, []);

  if (online) return null;

  return (
    <RenderInBody>
      <Modal
        warning
        icon
        title={t('connectivity_title')}
      >
        <p>{t('connectivity_text')}</p>
      </Modal>
    </RenderInBody>
  );
};

export default OfflineBubble;
